function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import * as React from "react";
import { get } from "../../utils/get";
import { Logger } from "../../utils/Logger";
import { set } from "../../utils/set";
import { useIsMounted } from "../../utils/useIsMounted";
import { useMountedState } from "../../utils/useMountedState";
import { findFirstVisibleErroneousField, isFocusableElement, isValidationError } from "./formUtils";
var logger = new Logger("Form");
export var createForm = function createForm(context, setDataRef) {
  return function Form(props) {
    var _this = this;
    var _useMountedState = useMountedState({}),
      _useMountedState2 = _slicedToArray(_useMountedState, 2),
      difference = _useMountedState2[0],
      setDifference = _useMountedState2[1];
    var isMounted = useIsMounted();
    var onChange = props.onChange,
      onSubmit = props.onSubmit,
      style = props.style,
      className = props.className,
      children = props.children,
      isDisabled = props.disabled,
      isCompact = props.compact;
    React.useEffect(function () {
      // For controller form, we don't need setData
      if (!setDataRef) {
        return undefined;
      }
      // eslint-disable-next-line no-param-reassign -- It's meant for reference usage (expected)
      setDataRef.current = {
        setData: function setData(newData) {
          setDifference(function (prevDiff) {
            return Object.assign(Object.assign({}, prevDiff), newData);
          });
        }
      };
      return function () {
        // eslint-disable-next-line no-param-reassign -- It's meant for reference usage cleanup
        setDataRef.current = {};
      };
    }, [setDifference]);
    React.useEffect(function () {
      var _a;
      return context.updateValidationResults((_a = props.validatorResults) !== null && _a !== void 0 ? _a : []);
    }, [props.validatorResults]);
    var onSave = React.useCallback(function (event) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, erroneusElement;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              context.updateOptions({
                disabled: true
              });
              _context.prev = 2;
              if (onSubmit) {
                _context.next = 6;
                break;
              }
              logger.error("ON_SUBMIT_WITHOUT_CALLBACK");
              return _context.abrupt("return");
            case 6:
              // Do not give access to internal data
              data = context.getDataClone();
              if (!data) {
                _context.next = 12;
                break;
              }
              _context.next = 10;
              return onSubmit({
                data: data,
                difference: difference
              });
            case 10:
              context.updateValidationResults([]);
              setDifference({});
            case 12:
              _context.next = 22;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              if (!(isValidationError(_context.t0) && isMounted.current)) {
                _context.next = 21;
                break;
              }
              erroneusElement = findFirstVisibleErroneousField(_context.t0.validatorResults);
              context.updateValidationResults(_context.t0.validatorResults);
              if (erroneusElement) {
                erroneusElement.scrollIntoView();
                if (isFocusableElement(erroneusElement)) {
                  // Set focus in the new event loop entry, not in the same as setState() call
                  // Otherwise we will lose focus event :)
                  setTimeout(function () {
                    erroneusElement.focus();
                  }, 0);
                }
              }
              return _context.abrupt("return");
            case 21:
              throw _context.t0;
            case 22:
              _context.prev = 22;
              context.updateOptions({
                disabled: false
              });
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 14, 22, 25]]);
      }));
    }, [onSubmit, difference, setDifference, isMounted]);
    React.useEffect(function () {
      return context.subscribe(function (fieldPath, fieldValue) {
        /*
        !FieldPath[0] === True when the root level gets updated
         This can happen
         a) Controlled form root value gets updated - there is no need to notify about the change, user just wanted it
         b) setData is called - we don't want to call onChange
         **Reasoning for not wanting to call it**
         If we decide to call it, we have a problem where we cannot call it for each key that user passes, otherwise we will be infinite loop
         const onChange = React.useCallback(
            (change: FormChange<Data>) => {
                if (change.event.name === "country") {
                    setData({
                        ...change.data,
                        city: undefined,
                    });
                }
            },
            [setData],
        );
         This example would end up in the inifnite loop, because we see that all the fields change -> we need to notify about the change.
        Deep comparison between update and current state can fix it, but why to overcomplicate when setData is anyway called in case of an event - user can already set the correct data and not
        hide the fixing of data into onChange handlers
        */
        if (!fieldPath[0]) {
          return;
        }
        setDifference(function (prevDiff) {
          var newDiff = Object.assign({}, prevDiff);
          set(newDiff, fieldPath, fieldValue);
          if (onChange && fieldPath.length) {
            var data = context.getDataClone();
            var rootField = fieldPath[0];
            var rootFieldValue = get(data, [rootField]);
            // Call onChange next tick - after setDifference has finished
            // Otherwise change can cause another change where difference becomes outdated
            setTimeout(function () {
              onChange({
                data: data,
                difference: newDiff,
                event: {
                  name: rootField,
                  value: rootFieldValue
                }
              });
            }, 0);
          }
          return newDiff;
        });
      });
    }, [onChange, setDifference]);
    React.useEffect(function () {
      context.updateOptions({
        compact: isCompact
      });
      context.onLoad(function () {
        context.updateOptions({
          disabled: isDisabled
        });
      });
    }, [isCompact, isDisabled]);
    React.useEffect(function () {
      if (props.onLoad) {
        context.onLoad(function () {
          if (props.onLoad) {
            var data = props.onLoad(context.getDataClone());
            if (data) {
              context.update(data);
            }
          }
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps -- Expected, it's only happening during initial load
    }, []);
    if (props.subform) {
      return /*#__PURE__*/React.createElement("div", {
        style: style,
        className: className
      }, children);
    }
    // Keep form method = POST, in case browser fails, it will not add querystring that can store sensitive
    // information in the browser history
    return /*#__PURE__*/React.createElement("form", {
      method: "POST",
      style: style,
      onSubmit: onSave,
      className: className
    }, children);
  };
};
export var createControlledForm = function createControlledForm(context) {
  var ControlledForm = createForm(context);
  return function Form(props) {
    /* Bind value to context */
    React.useEffect(function () {
      return props.value && context.update(props.value);
    }, [props.value]);
    /* End of bindings */
    return /*#__PURE__*/React.createElement(ControlledForm, Object.assign({}, props));
  };
};